import { createDirectionalZoneDetector } from "./zoneShared";

export const detectDemandZones = createDirectionalZoneDetector({
  zoneName: "demand",
  zoneLabel: "Demand",
  isDemand: true,
});
